export default {
  plan: {
    successfullyUpdated: 'plan.successfullyUpdated',
  },
};
